<template>
    <div class="tempControlDevice" :class="getClass()">
        <div class="tempControlDevice__progress" ref="progress">
            <i class="tempControlDevice__order"
            :class="{ soft: dragPosition == null }"
            :style="getStylePosition(orderPosition, true)"
            @touchstart="dragStart"
            @mousedown="dragStart">
            <span>{{ $castMetric(orderNumber) }}º</span>
            </i>
            <i
                class="tempControlDevice__real"
                :class="{ 'tempControlDevice__real--outRange': realPosition < 0 || realPosition > 100 }"
                :style="getStylePosition(realPosition, false)"
            >
                {{ $castMetric(real) }}º
            </i>
            <i class="tempControlDevice__min">{{ $castMetric(min) }}º</i>
            <i class="tempControlDevice__max">{{ $castMetric(max) }}º</i>
        </div>
        <i class="tempControlDevice__thermometer"></i>
        <i class="tempControlDevice__minus" v-if="status" @click.stop="minus"></i>
        <i class="tempControlDevice__plus" v-if="status" @click.stop="plus"></i>
    </div>
</template>

<script>
    export default {
        name: 'ui-TempControlDevice',
        props: {
            min: Number,
            max: Number,
            real: Number,
            order: Number,
            status: {
                // false: apagado; true: encendido
                type: Boolean,
                default: false,
            },
            standby: {
                // true: en modo de espera, SOLO cuando esta encendido
                type: Boolean,
                default: false,
            },
            vertical: {
                type: Boolean,
                default: false,
            },
            minMaxHidden: {
                type: Boolean,
                default: false,
            },
            modeHeat: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                step: 0.5,
                dragPosition: null,
            };
        },
        methods: {
            getClass: function() {
                var classStyles = '';

                if (this.vertical) classStyles = 'tempControlDevice--vertical';
                if (this.minMaxHidden) classStyles = `${classStyles} tempControlDevice--minMaxHidden`;
                // if (this.order == this.real) classStyles = `${classStyles} tempControlDevice--standby`;
                if (!this.status) classStyles = `${classStyles} tempControlDevice--off`;
                if (this.standby) classStyles = `${classStyles} tempControlDevice--standby`;
                if (this.modeHeat) classStyles = `${classStyles} modeHeat`;

                return classStyles;
            },
            getControl: (val) => (val < 0 ? 0 : val > 100 ? 100 : val),
            getStylePosition: function(val, isOrder) {
                let style = {
                    styleObject: {},
                };
                style[this.positionOrigin] = this.getControl(val) + '%';
                if (this.vertical && isOrder)
                    style['cursor'] = (this.dragPosition == null) ? 'grab' : 'grabbing';
                return style;
            },
            plus() {
                if (this.order < this.max) this.$emit('update:order', this.order + this.step);
            },
            minus() {
                if (this.order > this.min) this.$emit('update:order', this.order - this.step);
            },
            dragCommon: function($event) {
                if (!this.vertical) return;
                if ($event.touches){
                    if ($event.touches.length !== 1) return;
                    $event = $event.touches[0];
                };
                this.dragPosition = $event.clientY;
            },
            dragStart: function($event) {
                this.dragCommon($event);
                window.addEventListener('mousemove', this.drag, false);
                window.addEventListener('touchmove', this.drag, false);
                window.addEventListener('touchend', this.dragEnd, false);
                window.addEventListener('mouseup', this.dragEnd, false);
            },
            drag: function($event) {
                this.dragCommon($event);
            },
            dragEnd: function() {
                if (!this.vertical) return;

                window.removeEventListener('mousemove', this.drag, false);
                window.removeEventListener('touchmove', this.drag, false);
                window.removeEventListener('touchend', this.dragEnd, false);
                window.removeEventListener('mouseup', this.dragEnd, false);

                this.$emit('update:order', this.orderNumber);
                this.dragPosition = null;
            },
        },
        computed: {
            realPosition: function() {
                return ((this.real - this.min) * 100) / (this.max - this.min);
            },
            orderNumber: function() {
                if (this.dragPosition == null) return this.order;

                var value = (((this.max - this.min) * this.orderPositionDraw) / 100) + this.min;
                var valueMin = Math.round(value);
                var valueMax = valueMin + this.step;

                var difMin = value - valueMin;
                var difMax = valueMax - value;

                var result = (difMax > difMin) ? valueMin : valueMax;
                if (result > this.max) return this.max;
                if (this.min > result) return this.min;
                return result;
            },
            orderPosition: function() {
                if (this.dragPosition != null) return this.orderPositionDraw;
                return ((this.order - this.min) * 100) / (this.max - this.min);
            },
            orderPositionDraw: function() {
                var container = this.$refs.progress.getBoundingClientRect();
                var maxPosition = container.top;
                var minPosition = maxPosition + container.height;
                return ((this.dragPosition - minPosition) * 100) / (maxPosition - minPosition);
            },
            positionOrigin: function() {
                return this.vertical ? 'bottom' : 'left';
            },
        },
    };
</script>
